var _defs, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#ffffff;}.cls-3{fill:#ffba50;}.cls-4{fill:#c6b9c4;}.cls-5{fill:#8d7f89;}.cls-6{fill:#7cc05b;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.1,42.161l-7.424-7.426a1.368,1.368,0,0,0-1.2-.344L33.616,31.53A10.742,10.742,0,0,0,33.22,18V7a2.5,2.5,0,0,0-2.5-2.5H7A2.5,2.5,0,0,0,4.5,7V43A2.5,2.5,0,0,0,7,45.5H30.72a2.5,2.5,0,0,0,2.5-2.5V35.306l1.162,1.162a1.133,1.133,0,0,0,.354,1.206L42.16,45.1a1.371,1.371,0,0,0,1.937,0l1-1a1.369,1.369,0,0,0,0-1.936Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.22,43a1.5,1.5,0,0,1-1.5,1.5H7A1.5,1.5,0,0,1,5.5,43V7A1.5,1.5,0,0,1,7,5.5H30.72A1.5,1.5,0,0,1,32.22,7v9.985a10.806,10.806,0,1,0-.69,16.631l.69.69Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 25.016,
    cy: 25.016,
    r: 9.806
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25.016,
    cy: 25.016,
    r: 8.037
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25.016,
    cy: 25.016,
    r: 7.037
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.573,34.9l-.672.672-2.6-2.6c.234-.215.457-.438.672-.672Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.392,43.39l-1,1a.379.379,0,0,1-.523,0l-7.424-7.425a.369.369,0,0,1,0-.522l1-1a.365.365,0,0,1,.261-.108.372.372,0,0,1,.262.108l7.424,7.425a.369.369,0,0,1,0,.522Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.6,17.269l1.653-1.656a.5.5,0,0,0,.046-.654l-.595-.791.979-.138a.5.5,0,0,0,.429-.495V11.193a.5.5,0,0,0-.429-.495L16.7,10.56l.595-.792a.5.5,0,0,0-.046-.653L15.6,7.458a.5.5,0,0,0-.655-.046l-.789.595-.137-.979a.5.5,0,0,0-.5-.431H11.186a.5.5,0,0,0-.5.431l-.137.979-.788-.594a.5.5,0,0,0-.655.045L7.457,9.115a.5.5,0,0,0-.046.653l.6.792-.979.138a.5.5,0,0,0-.43.495v2.342a.5.5,0,0,0,.43.495l.979.138-.6.791a.5.5,0,0,0,.046.654L9.11,17.269a.5.5,0,0,0,.655.046l.788-.594.137.979a.5.5,0,0,0,.5.43h2.337a.5.5,0,0,0,.5-.43l.137-.98.789.6A.5.5,0,0,0,15.6,17.269Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.08,15.41a.5.5,0,0,0-.8.33l-.2,1.39H11.62l-.195-1.39a.5.5,0,0,0-.8-.329l-1.119.843L8.471,15.213l.843-1.122a.5.5,0,0,0-.33-.795L7.6,13.1V11.627l1.387-.2a.5.5,0,0,0,.33-.8L8.471,9.514,9.51,8.473l1.119.844a.5.5,0,0,0,.8-.329L11.62,7.6h1.469l.2,1.391a.5.5,0,0,0,.8.329l1.12-.844,1.039,1.041L15.4,10.636a.5.5,0,0,0,.329.8l1.387.2V13.1l-1.387.2a.5.5,0,0,0-.329.8l.843,1.122L15.2,16.255Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.016,21.834a5.881,5.881,0,0,0-5.095,2.927.5.5,0,0,0,0,.51,5.9,5.9,0,0,0,10.189,0,.5.5,0,0,0,0-.51A5.881,5.881,0,0,0,25.016,21.834Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.016,27.136a2.121,2.121,0,1,1,2.121-2.12A2.123,2.123,0,0,1,25.016,27.136Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.942,25.016a4.994,4.994,0,0,1,1.226-1.266,3.065,3.065,0,0,0,0,2.531A4.993,4.993,0,0,1,20.942,25.016Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.863,26.281a3.059,3.059,0,0,0,0-2.531,4.994,4.994,0,0,1,1.226,1.266A5.006,5.006,0,0,1,27.863,26.281Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.354,
    cy: 12.364,
    r: 2.508
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.354,
    cy: 12.364,
    r: 1.508
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection);
export default __webpack_public_path__ + "static/media/Inspection.797059ab2550970b1b340af2a22c3434.svg";
export { ForwardRef as ReactComponent };